import { useEffect, useState } from "react";

export const evaluators = {
    lessThan: (p: number) => (val: number, _?: boolean) => val < p,
    lessOrEqualThan: (p: number) => (val: number, _?: boolean) => val <= p,
    biggerThan: (p: number) => (val: number, _?: boolean) => val > p,
    biggerOrEqualThan: (p: number) => (val: number, _?: boolean) => val >= p,
    isPortrait: () => (_: number, isPortrait: boolean) => isPortrait,
};

type TUseWindowSizeMatch = {
    condition: (v: number, isPortrait: boolean) => boolean;
};
export const useWindowSizeMatch = ({ condition }: TUseWindowSizeMatch) => {
    const isPortrait = () =>
        window.matchMedia("(orientation: portrait)").matches;

    const [conditionFulfilled, setConditionFulfilled] = useState<{
        fulfilled: boolean;
    }>({ fulfilled: condition(window.innerWidth, isPortrait()) });

    useEffect(() => {
        const handleResize = () => {
            const evaluationResult = condition(window.innerWidth, isPortrait());
            setConditionFulfilled((prev) => {
                if (prev.fulfilled === evaluationResult) return prev;
                return {
                    fulfilled: evaluationResult,
                };
            });
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        conditionFulfilled,
    };
};
